export const getArticleLink = (article) => {
  if (article?.bookClubId) {
    return "/community/book-club";
  }

  if (article?.readingOrder?.id) {
    return `/browse/${article.readingOrder.id}/preview`;
  }

  return article?.link;
};
